import Div from '@/shared/Div';
import classNames from 'classnames';
import React from 'react';
import Button from '@/shared/Button';
import Paragraph from '@/shared/Paragraph';
import NoDeviceIcon from '../Icons/NoDevice';
import { useProfileContext } from '@/context/profileContext';
import useScreen from '@/hooks/useScreen';

function NoDeviceCard({ className }: { className?: string }) {
  const { state: profileState } = useProfileContext();
  const { isMobile } = useScreen();
  return (
    <Div
      className={classNames(
        'flex flex-col border border-neutral-50 gap-s6 py-6 font-primary bg-white shadow-medium rounded-cs',
        className,
      )}
    >
      <Div className="flex items-start px-6 flex-col gap-s6">
        <Paragraph className="text-h-3">No devices found</Paragraph>
        <NoDeviceIcon />
        <Paragraph>{`There are no devices linked to this phone number${
          profileState.primary_mobile_number ? ` - ${profileState.primary_mobile_number}.` : '.'
        }`}</Paragraph>
      </Div>

      <Div className="px-6">
        <Div className="flex flex-col gap-s5">
          {isMobile ? (
            <Button href={'tel:18602661177'} className="w-full" theme="secondary">
              Contact customer care
            </Button>
          ) : null}

          {isMobile ? null : (
            <Button
              external
              href={'https://www.eurekaforbes.com/connect-with-us'}
              className="w-full"
              theme="secondary"
            >
              Contact customer care
            </Button>
          )}
        </Div>
      </Div>
    </Div>
  );
}

export default NoDeviceCard;
